const WIZARD_COMPLETE_KEY = 'swiftaid-dashboard-welcome-wizard-v1'
const NOTIFICATION_SNOOZE_KEY = 'swiftaid-dashboard-welcome-notification-snoozed'

/** Whether the donor has finished or skipped the dashboard welcome wizard. */
export function isWelcomeWizardComplete(): boolean {
  try {
    return localStorage.getItem(WIZARD_COMPLETE_KEY) === '1'
  } catch {
    return false
  }
}

/** Persist wizard completion so the welcome notification does not return. */
export function markWelcomeWizardComplete(): void {
  try {
    localStorage.setItem(WIZARD_COMPLETE_KEY, '1')
    sessionStorage.removeItem(NOTIFICATION_SNOOZE_KEY)
  } catch (error) {
    console.warn('Could not persist welcome wizard completion', error)
  }
}

/** Hide the welcome notification until the browser session ends. */
export function snoozeWelcomeNotification(): void {
  try {
    sessionStorage.setItem(NOTIFICATION_SNOOZE_KEY, '1')
  } catch (error) {
    console.warn('Could not snooze welcome notification', error)
  }
}

/** Whether the welcome notification is snoozed for this session. */
export function isWelcomeNotificationSnoozed(): boolean {
  try {
    return sessionStorage.getItem(NOTIFICATION_SNOOZE_KEY) === '1'
  } catch {
    return false
  }
}
